import { render, staticRenderFns } from "./SdsTableSection3Material.vue?vue&type=template&id=fd8e29d6"
import script from "./SdsTableSection3Material.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection3Material.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports